import TableRenderer from '../TableRenderer';
import { ContentEditable } from 'edrolo-style-guide';
import { WordBank } from '../WordBank';
import { useWordBank } from '../DragAndDrop';
import style from './style.scss';

function stripHtml(html) {
  const withNewlines = html.replace(/<br>/g, '\n');
  const divContainer = document.createElement('div');
  divContainer.innerHTML = withNewlines;
  return divContainer.textContent || divContainer.innerText || '';
}
/* eslint-disable react/prop-types */ // TODO: add props

export const ClozeTableText = ({
  blockData,
  blockResponse,
  onResponseChange,
  readOnly,
}) => {
  const { content, withHeadings, options } = blockData;
  const { response_values: responseValues = [] } = blockResponse || {};

  const { usedOptionIndices } = useWordBank(options, responseValues);

  if (readOnly) {
    return (
      <TableRenderer
        content={content}
        renderResponseField={(responseFieldIndex, isHeading) => {
          const value = responseValues[responseFieldIndex];

          return (
            <TableRenderer.Cell
              isHeading={isHeading}
              isResponse
              className={style.responseCell}
            >
              {(value ?? value) || ''}
            </TableRenderer.Cell>
          );
        }}
        withHeadings={withHeadings}
      />
    );
  }
  return (
    <>
      <WordBank words={options} usedIndices={usedOptionIndices} />
      <TableRenderer
        content={content}
        renderResponseField={(responseFieldIndex, isHeading) => {
          return (
            // a content editable cell offers the best UX for entering
            // data into a cell as it behaves as a textarea that
            // seamlessly automatically grows with the content.
            // However we need to undo the ability to use html so there's a
            // a function used here to strip any actual html that might be
            // entered. Additionally, we need to convert <br> to newlines
            // and preserve them by applying the white-space: pre-wrap style
            // both here and in the read only view.
            <ContentEditable
              className={style.responseCell}
              tagName={isHeading ? 'th' : 'td'}
              data-response-cell
              defaultValue={responseValues[responseFieldIndex] || ''}
              onChange={(value) => {
                if (readOnly) {
                  return null;
                }
                const textValue = stripHtml(value).trim();
                const newResponseValues = [...responseValues];
                newResponseValues[responseFieldIndex] = textValue;
                onResponseChange({ response_values: newResponseValues });
              }}
            />
          );
        }}
        withHeadings={withHeadings}
      />
    </>
  );
};
